export default "__VITE_ASSET__7a74fc83__"